<template>
    <div class="createCampaignContainer">
        <div class="newCampaign">
            <div class="heading">
                <img class="backArrow" src="../assets/backArrow.svg" @click="onBackClick"/>
                <p class="title">{{title}}</p>
            </div>
            <div class="btnWrapper">
                <div @click="ondiscardClick" class="btn">Discard</div>
                <!-- <div @click="onSubmitBtnClick('save_as_draft')" class="btn">Save as Draft</div> -->
                <div
                    v-if="saveBtnClicked && validation"
                    @click="onSubmitBtnClick('submit_adGroup')"
                    :class="`${this.adGroupsListData?.find(item => item.keywords[0]?.match_type === 2) && 
                        (role === 'BRAND' || role === 'SELLER') ? 'disabledCreateBtn' : ''} submitBtn`"
                >
                    Submit
                </div>
                <div v-else @click="onSubmitBtnClick('submit_campaign')" class="submitBtn">Save & continue</div>
            </div>
        </div>
        <div v-if="showConfirmationModal">
            <ConfirmationModal @buttonClicked="onFormClear" :warnMessage='warnMessage' :leftButton="'Cancel'" :rightButton="'Discard'"
                @cancelClicked="onCloseModal" />
        </div>
        <CampaignDetails 
            :isNewCampaign="this.isNewCampaign" 
            @validationCheck="validate" 
            @submitclicked="onBackClick" 
            :adGroupsListData="this.adGroupsListData" 
            :campaignData="this.campaignData" 
            :sellerIdRole="this.sellerIdRole" 
            :saveBtnClicked="this.saveBtnClicked"  
            ref="campaignRef"
            :editCampaign="this.editCampaign"
            @updateName="onNameUpdate"
        />
    </div>
</template>

<script>
import LeftMenu from './LeftMenu.vue'
import CampaignDetails from './CampaignDetails.vue'
import ConfirmationModal from './ConfirmationModal.vue'
import Header from './Header.vue'
import { getCookie } from '@/services/campaignService'

export default {
    name: 'CreateCampaign',
    components: {
        Header,
        LeftMenu,
        CampaignDetails,
        ConfirmationModal
    },
    props: {
        campaignData: {
            type: Object,
            default: () => { }
        },
        adGroupsListData: {
            type: Object,
            default: () => { }
        },
        isNewCampaign: {
            type: Boolean,
            default: () => true
        },
        sellerIdRole: String,
        editCampaign: Boolean
    },
    data() {
        return {
            title:'New Campaign',
            warnMessage: 'Discard will permanantly delete any changes made to this form',
            showConfirmationModal: false,
            saveBtnClicked: false,
            formData: {},
            validation: false,
            role: getCookie('role')
        }
    },
    mounted(){
        if(!this.isNewCampaign && this.campaignData && this.campaignData.name ){
            this.title = this.decodeString(this.campaignData?.name);
        }
    },
    methods: {
        onBackClick(){
            this.$emit('backClicked')
        }, 
        decodeString(value){
            return atob(value)
        },
        ondiscardClick() {
            this.showConfirmationModal = !this.showConfirmationModal
        },
        onFormClear(){
            this.showConfirmationModal = false
            this.$refs.campaignRef.onFormClear();
        },
        onCloseModal() {
            this.showConfirmationModal = false
        },
        onSubmitBtnClick(action){
            if(action === 'submit_campaign'){
                this.$refs.campaignRef.onSubmit(action);
                this.saveBtnClicked = true;
            }else{
                this.$refs.campaignRef.onSubmit(action);
            }
        },
        validate(value){
            this.validation = value;
        },
        onNameUpdate(value){
            this.title = value;
        }
    }
}
</script>

<style scoped>
@font-face {
    font-family: "Inter-Regular";
    src: url('../assets/fonts/Inter-Regular.ttf');
}

.plusIcon {
    margin-right: 18px;
    font-weight: 400;
    font-size: 20.4818px;
    line-height: 25px;
}

.submit {
    display: flex;
    justify-content: center;
    font-style: normal;
    font-weight: 700;
    font-size: 20.4818px;
    line-height: 25px;
    color: #FFFFFF;
    padding: 16px;
    background: #2E31BE;
    border-radius: 12px;
    text-align: center;
    margin: 1%;
    cursor: pointer;
}

.backArrow{
   cursor: pointer;
}
.title{
    margin-left:20px;
}
.newAdGroup {
    cursor: pointer;
    margin: 1%;
    padding: 14px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
    border: 1px dashed #D3D3D3;
    border-radius: 12px;
}

.createCampaignContainer {
    font-family: 'Inter-Regular';
    background: #F8F8F8;
    display: flex;
    flex-direction: column;
}
.campaignData{
    display: flex;
    flex-direction: column;
}

.newCampaign {
    /*max-width: 1189px;
    margin: 0 0 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 100px 38px 22px;
    background: #FFFFFF;*/

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-family: 'Inter-Regular';
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    color: #401D0C;
    padding: 8px 20px 0px;
    margin-left: 0;
    background: #FFFFFF;
}

.heading {
    display: flex;
    flex-direction: row;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    color: #333333;
    margin: 0;
}

.btnWrapper {
    display: flex;
    align-items: center;
    flex-direction: row;
}

.btn {
    font-style: normal;
    cursor: pointer;
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    text-align: center;
    color: #2E31BE;
    padding: 7px 16px;
    border: 1px solid #2E31BE;
    border-radius: 5px;
    width: fit-content;
    margin-right: 18px;
}

.submitBtn {
    background: #2E31BE;
    /* opacity: 0.3; */
    border-radius: 4px;
    color: #FFFFFF;
    padding: 9px 16px;
    cursor: pointer;
}

.bottomcontainer{
    display: flex;
    flex-direction: column;
}

.disabledCreateBtn {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
}
</style>
